import * as React from "react"

import useStatefulField from "shared/hooks/useStatefulField"

import { BaseCell, BaseCellProps } from "../shared/BaseCell"
import { BaseInput, BaseInputContent } from "../shared/Styles.BaseInput"

export interface InputCellProps extends BaseCellProps {
  initialValue: string
  onChange: (value: string) => void
}

const InputCell = ({ initialValue, onChange, ...cellProps }: InputCellProps): JSX.Element => {
  const { value, handleChange, handleBlur } = useStatefulField({ initialValue, onChange })

  const [hasFocus, setHasFocus] = React.useState(false)

  const handleFocusForInput = (): void => {
    setHasFocus(true)
  }

  const handleBlurForInput = (): void => {
    setHasFocus(false)
    handleBlur()
  }

  return (
    <BaseCell {...cellProps}>
      <BaseInputContent hasFocus={hasFocus}>
        <BaseInput
          value={value}
          onChange={(event) => handleChange(event.target.value)}
          onFocus={handleFocusForInput}
          onBlur={handleBlurForInput}
        />
      </BaseInputContent>
    </BaseCell>
  )
}

export default InputCell
